export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20and%20deep%20red%20abstract%20geometric%20background%20with%20floating%20lottery%20balls%20and%20numbers%2C%20luxurious%20atmosphere%2C%20soft%20gradient%20lighting%2C%20Chinese%20lottery%20platform%20website%20hero%20background%2C%20modern%20clean%20aesthetic%2C%20professional%20atmosphere&width=1800&height=900&seq=hero-bg-lottery&orientation=landscape"
        alt="BB彩票平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <i className="ri-shield-check-line text-primary-300"></i>
            <span className="text-white/90 text-sm font-medium">持证合规 · 银行托管 · 安全可靠</span>
          </div>
          <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            BB彩票平台APP
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-2 font-heading">
            安全正规的手机彩票购买软件
          </p>
          <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto mb-8 leading-relaxed">
            支持双色球、大乐透、快三等多种彩票在线购买，实时开奖查询，极速到账，海量用户信赖之选。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300 hover:scale-105"
            >
              <i className="ri-download-2-line text-lg"></i>
              立即下载BB彩票APP
            </a>
            <a
              href="#features"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-medium rounded-full text-base whitespace-nowrap cursor-pointer border border-white/20 hover:bg-white/20 transition-all duration-300"
            >
              <i className="ri-arrow-down-line"></i>
              了解更多
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}